module.exports = "<div *ngIf=\"show\" class=\"backdrop full-screen\"></div>\r\n<div *ngIf=\"show\">\r\n    <div class=\"spinner-circle full-screen\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/loader/loader.component.html
// module id = nazb
// module chunks = 2